import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface Step {
  id: string;
  name: string;
  href: string;
  status: string;
}

const steps: Step[] = [
  { id: '1', name: 'Log In', href: '#', status: 'current' },
  { id: '2', name: 'Story Details', href: '#', status: 'upcoming' },
  { id: '3', name: 'Build My Character', href: '#', status: 'upcoming' },
  { id: '4', name: 'Build My Story', href: '#', status: 'upcoming' }
  // { id: '5', name: 'Purchase & Download', href: '#', status: 'upcoming' }
];

const StepsBar = ({ currentStep }: { currentStep: number }) => {
  const [currentLocation, setCurrentLocation] = useState<string | null>(null);

  const location = useLocation();

  useEffect(() => {
    setCurrentLocation(location.pathname);
  }, [location]);


  const updatedSteps = steps.map((step, index) => {
    if (index < currentStep) {
      return { ...step, status: 'complete' };
    } else if (index === currentStep) {
      return { ...step, status: 'current' };
    } else {
      return { ...step, status: 'upcoming' };
    }
  });

  return (
    <>
      {currentLocation === '/' && currentStep < 3 ? (
        <nav className={`${currentStep !== (steps.length - 1) && 'pt-[2rem]'}`} aria-label="Progress">
          <div className="relative flex items-center w-full">
            {updatedSteps.map((step, index) => {
              return (
                <div
                  key={step.name || index}
                  className={`h-1 w-full  ${
                    step.status === 'progress' || step.status === 'current' || step.status === 'complete'
                      ? 'bg-[#8dcbbd]'
                      : 'bg-transparent'
                  }`}
                ></div>
              );
            })}
          </div>
        </nav>
      ) : (
        ''
      )}
    </>
  );
};

export default StepsBar;